/*-----------------------------------------------------------------
- General translations
-----------------------------------------------------------------*/
export default {
    layout: {
        title      : 'خشکبار بانمک',
        separator  : '::',
        description: 'کوارک :: هسته‌ی قدرتمند یسناتیم',
    },

    all_products: '',

    footer: {
        contact_title: 'آدرس',
        phone_title  : 'تلفن',
    },

    404: {
        title       : 'صفحه‌ای که دنبال آن می‌گردید، وجود ندارد!',
        back_to_home: 'بازگشت به صفحه‌ی اصلی',
    },
};
